export const linksPath = '/links';
export const apikeysPath = '/api-clients';
export const workspacePath = '/workspace';
export const membersPath = '/members';
export const billingPath = '/billing';
export const dataExportsPath = '/data-exports';
